import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import SelectableCardsGroup, { CardItem } from '../../SelectableCardsGroup';
import { getError } from '../utils';

type Props = {
  cardList: CardItem[];
  fieldName: string;
  onChange: (value: { [key: string]: string }) => void;
  isExpanded: boolean;
  defaultActiveButton?: string;
};

export const SelectableCardsGroupForm: React.FC<
  React.PropsWithChildren<Props>
> = ({
  cardList,
  fieldName,
  onChange,
  isExpanded,
  defaultActiveButton = '',
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const [activeButton, setActiveButton] = React.useState(defaultActiveButton);

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <SelectableCardsGroup
          size={isExpanded ? 'lg' : 'xl'}
          list={cardList}
          isValid={!getError(fieldName, errors)}
          activeButton={activeButton}
          onClick={({ buttonKey }) => {
            const value = activeButton !== buttonKey ? buttonKey : '';
            setActiveButton(value);
            field.onChange(value);
            onChange({ [fieldName]: value });
          }}
        />
      )}
    />
  );
};
